// extracted by mini-css-extract-plugin
export default {"base":"ConfirmModal_base__dxPyF","text":"ConfirmModal_text__Q+IMA","button":"ConfirmModal_button__MLdzC","content":"ConfirmModal_content__Xg6XE"};